import LoadDirectionsMap from './LoadDirectionsMap';

export default LoadDirectionsMap;
